import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-20" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "text-muted"
}

import { useStore } from 'vuex';
import { ref, computed, onMounted } from 'vue';

import EpinioCatalogServiceModel from '../models/catalogservices';
import { EPINIO_PRODUCT_NAME, EPINIO_TYPES } from '../types';

import ResourceTable from '@shell/components/ResourceTable.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'catalogservices',
  props: {
    value: {}
  },
  setup(__props: any) {

const store = useStore();

const t = store.getters['i18n/t'];

const props = __props; // eslint-disable-line @typescript-eslint/no-unused-vars

const pending = ref<boolean>(true);

onMounted(async () => {
  await store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.SERVICE_INSTANCE });
  pending.value = false;
});

const servicesSchema = computed(() => {
  return store.getters[`${ EPINIO_PRODUCT_NAME }/schemaFor`](EPINIO_TYPES.SERVICE_INSTANCE);
});

const servicesHeaders = computed(() => {
  return store.getters['type-map/headersFor'](servicesSchema.value);
});

return (_ctx: any,_cache: any) => {
  const _component_LinkDetail = _resolveComponent("LinkDetail")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(t)('epinio.catalogService.detail.servicesTitle', { catalogService: _ctx.value.name })), 1),
    _cache[1] || (_cache[1] = _createTextVNode()),
    _createVNode(ResourceTable, {
      schema: servicesSchema.value,
      rows: _ctx.value.services,
      loading: pending.value,
      headers: servicesHeaders.value
    }, {
      "cell:boundApps": _withCtx(({ row }) => [
        (row.applications.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.applications, (app, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: app.id
                }, [
                  _createVNode(_component_LinkDetail, {
                    row: app,
                    value: app.meta.name
                  }, null, 8, ["row", "value"]),
                  _cache[0] || (_cache[0] = _createTextVNode()),
                  (index < row.applications.length - 1)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: app.id + 'i'
                      }, ", "))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, " "))
      ]),
      _: 1
    }, 8, ["schema", "rows", "loading", "headers"])
  ]))
}
}

})